import { generateBaseQueryKeysList } from '@/queries/utils';

export const ROUTE_PLANNER_KEYS = {
  main: 'logistics',
  route: 'route',
  recommendedFlights: 'recommended-flights',
  base: 'base',
  benchmark: 'benchmark',
  legs: 'legs',
  logs: 'logs',
  aircraftUtilization: 'aircraft-utilization',
};

export const routePlannerQueryKeys = {
  ...generateBaseQueryKeysList(ROUTE_PLANNER_KEYS.main),
  getLogistics: (...args: unknown[]) => [ROUTE_PLANNER_KEYS.main, ...args] as const,
  getLogisticsLogs: (...args: unknown[]) => [ROUTE_PLANNER_KEYS.main, ROUTE_PLANNER_KEYS.logs, ...args] as const,
  getRouteByType: (logisticsId: string, ...args: unknown[]) =>
    [ROUTE_PLANNER_KEYS.main, logisticsId, ROUTE_PLANNER_KEYS.route, ...args] as const,
  getRecommendedFlights: (...args: unknown[]) =>
    [ROUTE_PLANNER_KEYS.main, ROUTE_PLANNER_KEYS.recommendedFlights, ...args] as const,
  getBenchmark: (...args: unknown[]) => [ROUTE_PLANNER_KEYS.main, ROUTE_PLANNER_KEYS.benchmark, ...args] as const,
  getAircraftUtilization: (...args: unknown[]) =>
    [ROUTE_PLANNER_KEYS.main, ROUTE_PLANNER_KEYS.aircraftUtilization, ...args] as const,
};
